class ContentPostSettingsModalTab {
    constructor(contentPost) {
        this.contentPost = contentPost;
        this.modal = null;

        this.$element = this.buildElement();
        this.$tab = this.buildTabButton();

        this.bindEvents();
    }

    bindEvents() {

    }

    buildElement() {
        throw Error("Content Post Settings Modal Tab must implement 'buildElement");
    }

    buildTabButton() {
        return eotwJSXFactory('button', {class: "admin-modal__link", type: "button"}, [this.getName()]);
    }

    getElement() {
        return this.$element;
    }

    getTabButton() {
        return this.$tab;
    }


    getName() {
        throw Error("Content Post Settings Modal Tab must implement 'getName");
    }

    destroy() {
        //Noop
    }

    getValues() {
        return {};
    }
}

export default ContentPostSettingsModalTab;
